module.exports = __webpack_public_path__ + "7504757a900e3f11742c6e2b6d616b8e.svg";